// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { JsonValueSchema } from '../inputTypeSchemas/JsonValueSchema'
import { AiComponentTypeSchema } from '../inputTypeSchemas/AiComponentTypeSchema'
import { AiApplicationInterfaceTypeSchema } from '../inputTypeSchemas/AiApplicationInterfaceTypeSchema'
import { AiComponentProvenanceSchema } from '../inputTypeSchemas/AiComponentProvenanceSchema'
import { AiComponentVerificationStatusSchema } from '../inputTypeSchemas/AiComponentVerificationStatusSchema'
import { AiComponentSourceSchema } from '../inputTypeSchemas/AiComponentSourceSchema'

/////////////////////////////////////////
// AI COMPONENT SCHEMA
/////////////////////////////////////////

export const AiComponentSchema = z.object({
  type: AiComponentTypeSchema,
  interfaceType: AiApplicationInterfaceTypeSchema.nullable(),
  provenance: AiComponentProvenanceSchema.nullable(),
  verificationStatus: AiComponentVerificationStatusSchema.nullable(),
  sources: AiComponentSourceSchema.array(),
  id: z.string(),
  tenantId: z.string().nullable(),
  applicationId: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  role: z.string().nullable(),
  isInternal: z.boolean(),
  codeGraphId: z.string().nullable(),
  aiFlowGraphId: z.string().nullable(),
  canonicalKey: z.string().nullable(),
  runtimeOverlay: JsonValueSchema.nullable(),
  endpointId: z.string().nullable(),
  graphStaleAt: z.coerce.date().nullable(),
  metadata: JsonValueSchema.nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type AiComponent = z.infer<typeof AiComponentSchema>

export default AiComponentSchema;
